var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragDropImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 44,
    viewBox: "0 0 174 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179053"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6749",
    style: {
      fill: "#f3f6f9",
      stroke: "#203662",
      strokeDasharray: "4 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v43H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 172048"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21136",
    d: "M17.846 11.692A1.846 1.846 0 1 0 16 9.846a1.846 1.846 0 0 0 1.846 1.846zm0-2.462a.615.615 0 1 1-.615.615.615.615 0 0 1 .615-.614z",
    transform: "translate(71.615 8.462)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21135",
    d: "M3.231 20v1.231h2.822L2 25.284l.87.87L6.923 22.1v2.822h1.231V20z",
    transform: "translate(77 3.846)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21137",
    d: "M17.538 4H5.231A1.231 1.231 0 0 0 4 5.231v6.154h1.231V5.231h12.307v9.335l-2.209-2.209a1.231 1.231 0 0 0-1.735 0l-.978.978-3.8-3.8-.871.871 2.206 2.206 1.594 1.594a1.231 1.231 0 0 0 1.735 0l.978-.978 3.077 3.077v1.231h-6.15v1.231h6.154a1.231 1.231 0 0 0 1.231-1.231V5.231A1.231 1.231 0 0 0 17.538 4z",
    transform: "translate(76.231 10)",
    style: {
      fill: "#203662"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropImage);
export default __webpack_public_path__ + "static/media/drag_drop_image.aec5d8fddd3bc0ed7ebf7d66976437fb.svg";
export { ForwardRef as ReactComponent };